import React, { Component } from "react";
import EzSlider from "../ezSlider";
import InfoBand from "../rows/infoBand/infoBand";
import Image from "../image/image";
import Anchor from "../pageElements/anchor";
import ReactHtmlParser from "react-html-parser";
import "./imageSlider.css";

class ImageSlider extends Component {
  renderSlides() {
    return this.props.slides.map(item => (
      <div key={item.id} className="Slide">
        {item.bundle === "infoband" ? (
          <InfoBand config={item} slider={true} />
        ) : (
          <div
            style={{
              color: "#444",
              position: "relative",
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "32px"
            }}
          >
            <Image media={item.field_image} />
            <div
              style={{
                left: "0px",
                position: "absolute",
                display: "block",
                bottom: "0",
                right: "0",
                paddingRight: "16px",
                paddingLeft: "16px",
                marginTop: "0",
                marginLeft: "0px",
                marginBottom: "0px",
                maxHeight: "130px",
                background: "rgba(85, 85, 85, 0.5)",
                color: "#fff"
              }}
              className="caption"
            >
              <Anchor link={item.field_link_1}>
                {typeof item.field_text_1 === "undefined" ? null : (
                  <h2>{item.field_text_1}</h2>
                )}
                {typeof item.field_longtext_1 === "undefined"
                  ? null
                  : ReactHtmlParser(item.field_longtext_1)}
              </Anchor>
            </div>
          </div>
        )}
      </div>
    ));
  }

  static defaultProps = {
    arrowNav: {
      useArrow: true,
      right: "20px",
      left: "0px",
      top:
        (((window.innerWidth > 1200 ? 1200 : window.innerWidth) -
          (window.innerWidth > 899 ? 332 : 0)) *
          0.5625) /
          2 -
        18 +
        "px",
      arrowStyles: {
        position: "absolute",
        zIndex: "4444",
        backgroundColor: "rgb(255, 255, 255, 0.65)",
        padding: "5px 15px",
        cursor: "pointer",
        border: "none",
        opacity: "0.5"
      }
    },
    ulStyles: {
      padding: 0,
      margin: 0
    }
  };

  render() {
    return (
      <EzSlider
        slides={this.renderSlides()}
        navTop="50"
        navColor="#444"
        width="100%"
        borderRight="false"
        ulStyles={{
          ...this.props.ulStyles,
          marginBottom: "1em",
          overflow: "hidden"
        }}
        padding="0"
        settings={{
          className: "center",
          centerMode: true,
          centerPadding: "20px",
          borderRight: "false",
          isFull: true,
          arrowNav: this.props.arrowNav,
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          swipeToSlide: true
        }}
      />
    );
  }
}

export default ImageSlider;
